import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Container } from 'reactstrap'
import PropTypes from 'prop-types'

import BrandEngagementPlaceholder from '../../components/Brand/v1/Placeholder'
import { EngagementPlaceholderProps } from '../../types/props'

interface BrandEngagementV1Props {
  brandEngagementData?: Record<string, any>;
  hideCta?: boolean;
  isLiveStream?: boolean;
}

const BrandEngagementV1: React.FC<BrandEngagementV1Props> = ({ 
  brandEngagementData = {}, 
  hideCta = false,
  isLiveStream = false, 
}) => {
  const { state } = useLocation()

  const [isYoutubeOpen, setYoutubeOpen] = useState<boolean>(false)
  const [isBrochureOpen, setBrochureOpen] = useState<boolean>(false)

  const closeYoutube = () => {
    setYoutubeOpen(false)
  }

  const closeBrochure = () => {
    setBrochureOpen(false)
  }

  const handleBackClick = () => {
    if (isYoutubeOpen) closeYoutube()
    else if (isBrochureOpen) closeBrochure()
  }

  const engagementPlaceholderProps: EngagementPlaceholderProps = {
    handleBackClick,
    isYoutubeOpen,
    setYoutubeOpen,
    isBrochureOpen,
    setBrochureOpen,
    brandEngagement: state?.brandEngagement || brandEngagementData,
    productId: state?.productId,
    uniqueId: state?.uniqueId,
    hideCta,
    isLiveStream,
  }
  
  return (
    <Container
      className='app-background'
      style={{
        backgroundImage: `url(${state?.brandEngagement?.page?.background})`,
      }}
    >
      <div className='app-container'>
        <BrandEngagementPlaceholder {...engagementPlaceholderProps} />
      </div>
    </Container>
  )
}

BrandEngagementV1.propTypes = {
  brandEngagementData: PropTypes.object,
  hideCta: PropTypes.bool,
  isLiveStream: PropTypes.bool,
}

export default BrandEngagementV1